module.exports = __webpack_public_path__ + "media/images/of5-1490a499d5df1dfecd88f670687f28c5.jpg";